import { AutoAwesome, Instagram, Login } from '@mui/icons-material';
import React, { useState, useEffect, useCallback } from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { Link } from 'react-router-dom';
import { useUser } from '../context/UserContext';

const LoginPopup = () => {


     const { user } = useUser();
     const [open, setOpen] = useState(false);

     // Timer function jo har baar call hoga
     const startTimer = useCallback(() => {
          return setTimeout(() => {
               if (!user) {
                    setOpen(true);
               }
          }, 60000);
     }, [user]);

     useEffect(() => {
          let timer;
          if (!user && !open) {
               timer = startTimer();
          }
          return () => clearTimeout(timer);
     }, [open, user, startTimer]);


     const styles = {
          modal: {
               background: '#111111',
               borderRadius: '20px',
               padding: '0px',
               maxWidth: '400px',
               border: '1px solid #222',
               overflow: 'hidden'
          },
          overlay: {
               background: 'rgba(0, 0, 0, 0.85)',
               backdropFilter: 'blur(5px)'
          },
          closeButton: {
               fill: '#555'
          }
     };

     return (
          <Modal open={open} onClose={() => setOpen(false)} center styles={styles}>
               <div style={{ padding: '40px 30px', textAlign: 'center', fontFamily: "'Inter', sans-serif" }}>

                    {/* Top Branding Icon */}
                    <div style={{ marginBottom: '15px' }}>
                         <AutoAwesome sx={{ fontSize: 40, color: '#ff4b81' }} />
                    </div>

                    <h2 style={{ color: '#fff', fontSize: '24px', fontWeight: '700', margin: '0 0 10px 0' }}>
                         Unlock Millions of Prompts
                    </h2>

                    <p style={{ color: '#888', fontSize: '14px', lineHeight: '1.5', marginBottom: '30px' }}>
                         Create a free account to continue exploring AI-generated images and prompts.
                    </p>

                    {/* The Main Login Link - Styled like a premium button but it's an <a> tag */}
                    <div style={{ marginBottom: '20px' }}>
                         <Link to="/login"
                              onClick={() => setOpen(false)} style={{
                                   display: 'flex',
                                   alignItems: 'center',
                                   justifyContent: 'center',
                                   gap: '10px',
                                   outline: '0px',
                                   background: '#fff',
                                   color: '#000',
                                   padding: '14px',
                                   borderRadius: '12px',
                                   textDecoration: 'none',
                                   fontWeight: '700',
                                   fontSize: '16px',
                                   transition: '0.3s'
                              }}>
                              <Login sx={{ fontSize: 20 }} />
                              Continue with Login
                         </Link>
                    </div>

                    <div style={{ margin: '20px 0', display: 'flex', alignItems: 'center', gap: '10px' }}>
                         <div style={{ flex: 1, height: '1px', background: '#222' }}></div>
                         <span style={{ color: '#444', fontSize: '12px' }}>OR</span>
                         <div style={{ flex: 1, height: '1px', background: '#222' }}></div>
                    </div>

                    {/* Join Community Instagram Link */}
                    <div style={{ marginTop: '10px' }}>
                         <Link to="https://www.instagram.com/heyprompt.online/" target="_blank" rel="noreferrer"
                              style={{
                                   display: 'flex',
                                   alignItems: 'center',
                                   justifyContent: 'center',
                                   gap: '8px',
                                   textDecoration: 'none',
                                   fontSize: '15px',
                                   color: '#ff4b81'
                              }}
                         >
                              <Instagram sx={{ fontSize: 20 }} />
                              Join Community Instagram
                         </Link>
                    </div>

               </div>
          </Modal>
     );
};

export default LoginPopup;